import { useNavigate } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, Suspense } from "react";
import routes from "./config";
import { navigateResolver } from "./navigate";

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  return (
    <Suspense fallback={
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
        <div className="w-12 h-12 rounded-full border-4 border-gray-200 border-t-[#012676] animate-spin"></div>
      </div>
    }>
      {element}
    </Suspense>
  );
}
